var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "error",
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "error-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "error-2",
    transform: "translate(-404.000000, -160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "error-3",
    transform: "translate(404.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "error-4",
    d: "M128,0 L128,128 L0,128 L0,0 L128,0 Z M116,12 L12,12 L12,116 L116,116 L116,12 Z M70.2306874,83.4996492 C73.034768,85.1572497 74.7618031,88.2205414 74.7610619,91.5353041 C74.7618031,94.8500667 73.034768,97.9133585 70.2306874,99.570959 C67.4266069,101.228559 63.9716232,101.228559 61.1675427,99.570959 C58.3634621,97.9133585 56.636427,94.8500667 56.6371681,91.5353041 C56.636427,88.2205414 58.3634621,85.1572497 61.1675427,83.4996492 C63.9716232,81.8420488 67.4266069,81.8420488 70.2306874,83.4996492 Z M65.6991138,26.0530973 C70.7197803,26.0530973 74.7610619,30.2408559 74.7610619,35.4428646 L74.7610619,35.4428646 L72.0816681,68.3354611 C71.5687915,72.5997608 71.1265801,75.0122128 69.3862791,76.1426834 C68.2605378,76.6603143 67.0142101,76.9542459 65.6991138,76.9542459 C64.3776443,76.9542459 63.1259549,76.6569489 61.9959534,76.1345684 C60.2653375,75.0008952 59.8282909,72.5902444 59.3165595,68.3354611 L59.3165595,68.3354611 L56.6371681,35.4428646 C56.6371681,30.2408559 60.6784449,26.0530973 65.6991138,26.0530973 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "error-5",
    transform: "translate(57.000000, 26.000000)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.7223f4776d769f2a2080e99c89e65d64.svg";
export { ForwardRef as ReactComponent };